import { memoryCache } from 'mihoyo-store';
import { CACHE_INSTANCE_ID, CACHE_USER_LIST } from '@configPath/cacheConfigs/memoryCache.config';
import customEvent from 'mihoyo-custom-event';
import { PRE_POST, TO_MYPORNS } from '@configPath/eventConfigs/customEvent.config';
import model from '../../models/default';
import main from '../main';

// memoryCache的存在仅仅是为了演示多个模块之间共享数据的方法，可删除相关代码
// const memoryCache = Store.getInstance();

export default {

  /**
   * 视图容器对象
   * @returns {jQuery|HTMLElement}
   */
  el() {
    return $('#userList');
  },

  contribute() {
    return $('.page-1-contribute');
  },

  myContribute() {
    return $('.page-1-myporn');
  },

  interView() {
    return $('.page-1-interview');
  },

  /**
   * 视图渲染方法
   */
  render() {
    this.events();
  },

  /**
   * 视图事件集中绑定
   */
  events() {
    this.contribute().on('click', () => {
      customEvent.emit(PRE_POST, {});
    })
    this.myContribute().on('click', () => {
      customEvent.emit(TO_MYPORNS, {});
      main.jump('.page-1', '.page-5');
    })
    this.interView().on('click', () => {
      window.open('https://bbs.mihoyo.com/bh3/#/article/16853', '_blank');
    })
  }
}
